const initialState = {
    isLoading: false,
    sessionExpired: false
}

export function sessionExpiredReducer(state = initialState, action) {
    switch (action.type) {
        case 'SESSION_EXPIRED':
            return {
                isLoading: false,
                sessionExpired: true
            }
        case 'RESET_SESSION_EXPIRED':
            return {
                isLoading: false,
                sessionExpired: false
            }
        default:
            return state
    }
}

export default sessionExpiredReducer
